const API_BASE_URL =
  window.location.hostname === 'localhost' ? 'http://localhost:9090' : `https://${window.location.hostname}`

export const postSale = (req, token) =>
  fetch(`${API_BASE_URL}/payfwd`, {
    method: 'POST',
    headers: {
      Authorization: token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req),
  }).then((r) => r.json())

export const getSale = (transaction_id, token) =>
  fetch(`${API_BASE_URL}/getfwd/${transaction_id}`, {
    method: 'GET',
    headers: {
      Authorization: token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((r) => r.json())

export const getSaleRaw = (transaction_id, token) =>
  fetch(`${API_BASE_URL}/getfwd/raw/${transaction_id}`, {
    method: 'GET',
    headers: {
      Authorization: token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((r) => r.json())
